import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerGuard } from '../shop/guards/customer.guard';
import { DiscountViaUrlGuard } from '../shop/guards/discount-via-url.guard';
import { CartOverviewComponent } from './containers/cart-overview/cart-overview.component';
import { CartActionsGuard } from './guards/cart-actions.guard';

const routes: Routes = [
  {
    path: '',
    component: CartOverviewComponent,
    pathMatch: 'full',
    canActivate: [DiscountViaUrlGuard],
  },
  {
    path: 'add',
    component: CartOverviewComponent,
    canActivate: [CartActionsGuard],
  },
  {
    path: ':addToCartLine',
    component: CartOverviewComponent,
    canActivate: [CartActionsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CartRoutingModule {}
